import { Button, Steps, } from 'antd';
import React, { useEffect, useState } from 'react';
import { MembersPortalService } from '../../../../redux/services/MembersPortalService';
import { ITabReduxItem } from '../../../../redux/types/ITabReduxItem';
import { MembersPortalRoles } from '../../../../redux/types/MembersPortalRoles';
import { AGREEMENT_MAINTENANCE_GROUP, CONFIGURATION_PARAMETER_ALLOW_SPECIFIC_AGREEMENTS_WITH_NO_WORKS_KEY, CONFIGURATION_PARAMETER_SUBMITTER_MUST_BE_ASSOCIATED_FIELDS_KEY } from '../../../../repertoire/ConfigurationConsts';
import ActionButton from '../../../../repertoire/components/actionButton/ActionButton';
import { MessageBanner, MessageType } from "../../../../repertoire/components/messageBanner/MessageBanner";
import { DataSource } from '../../../../repertoire/types/DataSource';
import { SearchRequests } from '../../../services/SearchRequests';
enum FormPages {
    GeneralPage = 0,
    AssigneesPage = 1,
    WorksPage = 2,
    AttachmentPage = 4,
    CommentsPage = 3
}
export interface Step {
    title: string;
    content: any;
}
export interface IDraftAgreementsMaintenanceFormProps {
    steps: Step[];
    readonly: boolean;
    saveChanges: () => void;
    confirmAndSubmit: () => void;
    mapShareSetBundle?: (draftAgreement: any) => void;
    enableSetTypeBundle?: boolean;
    dataSource?: string;
    current?: number;
    setCurrent?: (current: number) => void;
    tabs?: ITabReduxItem
    activeTab?: number;
    resetMessageBanner: () => void;
    currentUserNameNumber: string;
    currentUserIpBaseNumber: string;
    stepsCurrent?: number;
    changesMade: boolean;
    draftAgreementMaintenanceGeneralDataViewData?: any;
}
const DraftAgreementsMaintenanceForm = (props) => {
    const GENERIC_TYPE = '1';
    const SPECIFIC_TYPE = '2';
    const EXCLUDE = "EX"
    const [submit, setSubmit] = useState(false)
    const [errorMessages, setErrorMessages] = useState([]);
    const [submitterMustBeAssociated, setSubmitterMustBeAssociated] = useState()
    const [allowSpecificAgreementsWithNoWorks, setAllowSpecificAgreementsWithNoWorks ] = useState(false);
    useEffect(() => {
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_SUBMITTER_MUST_BE_ASSOCIATED_FIELDS_KEY, AGREEMENT_MAINTENANCE_GROUP)
            .then((formats) => {
                setSubmitterMustBeAssociated(formats);
            })
    }, []); 
    useEffect(() => {
        SearchRequests.getConfigurationParameter(CONFIGURATION_PARAMETER_ALLOW_SPECIFIC_AGREEMENTS_WITH_NO_WORKS_KEY, AGREEMENT_MAINTENANCE_GROUP)
            .then((res) => {
                setAllowSpecificAgreementsWithNoWorks(res);
            })
    }, []);
    const handleSubmit = () => {
        setSubmit(props.confirmAndSubmit());
    }
    const next = () => {
        const { current, setCurrent, tabs, activeTab, currentUserNameNumber, currentUserIpBaseNumber,resetMessageBanner } = props;
        const next = current + 1;
        if(next === 4){
            resetMessageBanner();
        }
        switch (current) {
            case FormPages.GeneralPage:
                if (validateGeneralPage(tabs[activeTab].agreementMaintenanceState.agreement)) {
                    setCurrent(next)
                }
                break;
            case FormPages.AssigneesPage:
                if (validateAssigneePage(tabs[activeTab].agreementMaintenanceState.agreement, currentUserNameNumber, currentUserIpBaseNumber)) {
                    setCurrent(next);
                }
                break;
            case FormPages.WorksPage:
                if (isWorksPage(tabs[activeTab].agreementMaintenanceState.agreement)) {
                    if (validateWorksPage(tabs[activeTab].agreementMaintenanceState.agreement)) {
                        setCurrent(next)
                    }
                }
                if (props.enableSetTypeBundle) {
                    props.mapShareSetBundle(tabs[activeTab].agreementMaintenanceState.agreement);
                }
                if (isCommentsPage(tabs[activeTab].agreementMaintenanceState.agreement, FormPages.WorksPage)) {
                    if (validateCommentsPage(tabs[activeTab].agreementMaintenanceState.agreement)) {
                        if (!tabs[activeTab].agreementMaintenanceState.agreement?.status) {
                            props.saveChanges();
                        }
                        setCurrent(next)
                    }
                }
                break;
            case FormPages.AttachmentPage:
                setCurrent(next)
                break;
            case FormPages.CommentsPage:
                if (isCommentsPage(tabs[activeTab].agreementMaintenanceState.agreement, FormPages.CommentsPage)) {
                    if (validateCommentsPage(tabs[activeTab].agreementMaintenanceState.agreement)) {
                        props.saveChanges();
                        setCurrent(next)
                    }
                } else {
                    setCurrent(next)
                }
                break;
            default:
                setCurrent(next)

        }

    };

    const isCommentsPage = (state, pageNumber) => {
        return state.type === SPECIFIC_TYPE && pageNumber === FormPages.CommentsPage || state.type === GENERIC_TYPE && pageNumber === FormPages.WorksPage;
    }

    const validateCommentsPage = (state) => {
        const { draftAgreementMaintenanceGeneralDataViewData } = props;
        const messages = [];

        if (state.comments && state.comments.length > 0) {
            state.comments.forEach((comment) => {
                if (comment.commentCategory.value === null) {
                    messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "commentCategoryEmptyMessage")?.data || "Comment category cannot be empty.");
                }
            });
        }
        if (messages.length > 0) {
            setErrorMessages(messages);
            return false;
        }
        setErrorMessages([]);
        return true;
    }

    const isWorksPage = (state) => {
        return state.type === SPECIFIC_TYPE;
    }

    const validateWorksPage = (state) => {
        const { draftAgreementMaintenanceGeneralDataViewData } = props;
        const messages = [];

        if (isWorksPage(state)) {
            if (state.agreementWorks?.length > 0) {
                if (state?.agreementWorks[0]?.workName?.value === '') {
                    messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "workEmptyMessage")?.data || "Work cannot be empty.");
                }
            }
            if (((!allowSpecificAgreementsWithNoWorks || state.applicableWorksType === EXCLUDE) && (!state.agreementWorks || state.agreementWorks.length === 0))) {
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "workRequiredMessage")?.data || "Work required.");
            }
        }
        if (messages.length > 0) {
            setErrorMessages(messages);
            return false;
        }
        setErrorMessages([]);
        return true;
    }

    const validateAssigneePage = (state, currentUserNameNumber, currentUserIpBaseNumber) => {
        const { draftAgreementMaintenanceGeneralDataViewData } = props;
        const messages = [];

        let isAssignee = false;
        let isAssignor = false;

        state.agreementAdminIP && state.agreementAdminIP.length > 0 && state.agreementAdminIP.forEach((assignee) => {
            if (assignee?.administeredIP?.value == currentUserNameNumber || assignee?.assigneeNameNumber?.value == currentUserNameNumber || assignee?.administeredByIPBaseNumber?.value == currentUserIpBaseNumber) {
                isAssignee = true;
            }
        })

        if (state.agreementAdminIP.some(assignee => assignee?.assigneeNameNumber?.value === state.ipNameNumber)) {
            messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "assignorAssigneeSameMessage")?.data || "Assignor and Assignee cannot be the same.");
        }

        if (state?.ipNameNumber == currentUserNameNumber || state?.ipBaseNumber == currentUserIpBaseNumber) {
            isAssignor = true;
        }

        if (submitterMustBeAssociated) {
            if (!isAssignee && !isAssignor) {
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "assignorAssigneeRequiredMessage")?.data || "You must be the assignor or assignee required");
            }
        }

        if (!state.agreementAdminIP || state.agreementAdminIP.length === 0) {
            messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "assigneeRequiredMessage")?.data || "Assignee required");
        }
        if (state.agreementAdminIP && state.agreementAdminIP.length > 0) {
            let isAdministeredNameError = false;
            let isSocietyAffiliationError = false;
            let isShareValuesEqualZero = false;

            let toleranceUpperPerformer = 100.02;
            let toleranceUpperMechanical = 100.02;

            let performingShareTotal = 0;
            let mechanicalShareTotal = 0;

            let totalmechanicalShare = 0;
            let totalperformingShare = 0;
            

            state.agreementAdminIP.forEach((assignee) => {
                totalperformingShare = totalperformingShare + assignee.performingShare?.value + (assignee.creatorRetainedPerShare?.value ?? 0) + (assignee.publisherRetainedPerShare?.value ?? 0);
                totalmechanicalShare = totalmechanicalShare + assignee.mechanicalShare?.value + (assignee.creatorRetainedMechShare?.value ?? 0) + (assignee.publisherRetainedMechShare?.value ?? 0);
                if ((!assignee.administeredName || assignee.administeredName?.value === '') && !isAdministeredNameError) {
                    isAdministeredNameError = true;
                    messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "assigneeNameEmptyMessage")?.data || "Assignee name cannot be empty.");
                }
                if (((!assignee.performingShare || assignee.performingShare.value == '' || Number((assignee?.performingShare?.value)).toFixed(2) == '0.00' ) && (!assignee.mechanicalShare || assignee.mechanicalShare.value == '' || Number((assignee?.mechanicalShare?.value)).toFixed(2) == '0.00') ) && !isShareValuesEqualZero) {
                    isShareValuesEqualZero = true;
                    messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "assigneeShareValuesMessage")?.data || "Assignee needs to have either mechanical or performing share values");
                }
                if ((state.useRelationships == null || state.useRelationships === false) && (assignee.creatorRetainedPerShare?.value > 0 || assignee.publisherRetainedPerShare?.value > 0
                    || assignee.creatorRetainedMechShare?.value > 0 || assignee.publisherRetainedMechShare?.value > 0)) {
                    messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "retainedShareNotZeroMessage")?.data || "Creator/Publisher Retained Shares must be zero if the Use Relationship is not checked");
                }
                if (assignee?.performingShare?.value) {
                    performingShareTotal += parseFloat(Number((assignee?.performingShare?.value)).toFixed(2));
                }
                if (assignee?.mechanicalShare?.value) {
                    
                    mechanicalShareTotal += parseFloat(Number((assignee?.mechanicalShare?.value)).toFixed(2));
                }

            });

            if ((state.useRelationships !== false) && (totalperformingShare > 100 || totalperformingShare < 100))
            {
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "perfSharesDoNotEqualOneHundredMessage")?.data || "Performing shares in the Assignee grid should add up to 100%.");
            }
            if ((state.useRelationships !== false) && (totalmechanicalShare > 100 || totalmechanicalShare < 100))
            {
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "mechSharesDoNotEqualOneHundredMessage")?.data || "Mechanical shares in the Assignee grid should add up to 100%.");
            }

            if ( performingShareTotal > toleranceUpperPerformer) {
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "perfSharesExceedOneHundredMessage")?.data || "Performing share cannot exceed 100%");
            }
            if (mechanicalShareTotal > toleranceUpperMechanical) {
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "mechSharesExceedOneHundredMessage")?.data || "Mechanical share cannot exceed 100%");
            }

        }
        if (messages.length > 0) {
            setErrorMessages(messages);
            return false;
        }
        setErrorMessages([]);
        return true;
    };



    const validateGeneralPage = (state) => {
        const { draftAgreementMaintenanceGeneralDataViewData } = props;
        const messages = [];

        if (!state.ipName || state.ipName === '') {
            messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "ipNameEmptyMessage")?.data || "IP name cannot be empty");
        }
        if (!state.effectiveFrom || state.effectiveFrom === '') {
            messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "effectiveFromEmptyMessage")?.data || "Effective from date cannot be empty");
        }
        if (!state.agreementCategory || state.agreementCategory === '') {
            messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "agreementCategoryEmptyMessage")?.data || "Agreement category cannot be empty");
        }
        if (!state.type || state.type === '') {
            messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "typeEmptyMessage")?.data || "Type cannot be empty");
        }
        if ((!state.agreementShareSet || state.agreementShareSet.length === 0 ) && (!state.agreementShareSetBundle || state.agreementShareSetBundle.length === 0)) {
            messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "assignedSetTypeEmptyMessage")?.data || "Assigned set type cannot be empty");
        }
        if (state.agreementTerritory) {
            if(state.agreementTerritory.length===0){
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "agreementTerritoryEmptyMessage")?.data || "Agreement territory cannot be empty");
            }else{
                let includedTerritories = [];
                let excludedTerritories = [];
                state.agreementTerritory.map(item => {
                    if (item.include) {
                        includedTerritories.push(item)
                    } else {
                        excludedTerritories.push(item)
                    }
    
                })
                if (includedTerritories.length === 0) {
                    if (includedTerritories.length < excludedTerritories.length) {
                        messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "agreementExcludeWithoutIncludeMessage")?.data || "Agreement cannot have Exclude Territory without an Include Territory")
                    }
                }
            }
        }
        if(state.type==='2'){
            if(!state.applicableWorksType){
                messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "applicableWorksTypeEmptyMessage")?.data || "Applicable works type cannot be empty");
            }            
        }
        if(state.effectiveFrom && state.effectiveTo){
            let fromDate = new Date(state.effectiveFrom as any);
                let toDate = new Date(state.effectiveTo); 
                if (fromDate > toDate) {
                    messages.push(draftAgreementMaintenanceGeneralDataViewData.fields.find(x => x.name.toString() === "effectiveFromBeforeEffectiveToMessage")?.data || "Effective From date must be before Effective To date.");
                }
        }
        if (messages.length > 0) {
            setErrorMessages(messages);
            return false;
        }
        setErrorMessages([]);
        return true;
    };


    const prev = () => {
        const { current, setCurrent,resetMessageBanner } = props;
        if(current - 1 === 2){
            resetMessageBanner();
        }
        setErrorMessages([]);
        setCurrent(current - 1);
    };
    let validationErrors = !!(errorMessages.length > 0);
    const renderCloseErrorMessages = () => {
        setErrorMessages([]);};
    const items = props.steps.map((item) => ({ key: item.title, title: item.title }));
    const { current, dataSource, changesMade, tabs, activeTab } = props;

    const menuName = tabs[activeTab]?.name;
    const hasPermission = MembersPortalService.hasPermissionForMenu(menuName, MembersPortalRoles.FullAccess);

    return (
        <>
            {(dataSource === DataSource.Intray) ? <Steps current={current} items={items} /> : <></>}
            <div style={{ padding: '20px' }}>{props.steps[current].content}</div>
            {!(validationErrors && <MessageBanner resetMessageBanner={renderCloseErrorMessages} messageType={MessageType.Danger} messages={errorMessages} />) && document.querySelector('.loaderWrapper') == null && submit && <div
            >
                <MessageBanner messageType={MessageType.Success}
                    messages={[props.draftAgreementMaintenanceGeneralDataViewData?.fields.find(v => v.name == "draftSubmitted")?.data]}
                    resetMessageBanner={props.resetMessageBanner}
                />
            </div>
            }
            <div className="row">
                <div
                    className="btn-group form-group col-lg-2 col-lg-push-5 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                    style={{ marginTop: 24 }}
                >
                    {current > 0 && (
                        <Button data-testid={'prev'} className="button btn-defaultSecondary" onClick={() => prev()}>
                            {props.draftAgreementMaintenanceGeneralDataViewData?.fields.find(v => v.name == "previous")?.data}
                        </Button>
                    )}
                </div>
                <div
                    className="btn-group form-group col-lg-2 col-lg-push-5 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                    style={{ marginTop: 24 }}
                >
                    {current < props.steps.length - 1 && (
                        <Button data-testid={'next'} className="button btn-defaultSecondary" onClick={() => next()}>
                            {props.draftAgreementMaintenanceGeneralDataViewData?.fields.find(v => v.name == "next")?.data}
                        </Button>
                    )}
                </div>
                {current === props.steps.length - 1 && props.dataSource === DataSource.Intray && (
                    <>
                        <div
                            className="btn-group form-group col-lg-2 col-lg-push-3 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                            style={{ marginTop: 24 }}
                        >
                            <ActionButton buttonText={props.draftAgreementMaintenanceGeneralDataViewData?.fields.find(v => v.name == "saveChanges")?.data}
                                buttonAction={() => props.saveChanges()}
                                className="button btn-defaultSecondary"
                                data-testid={'save-registration'}
                                showTooltip={!hasPermission}
                                disabled={!changesMade} />
                        </div>
                        <div
                            className="btn-group form-group col-lg-2 col-lg-push-3 col-md-3 col-md-push-6 col-sm-6 col-sm-push-0 col-xs-12 col-xs-push-0"
                            style={{ marginTop: 24 }}
                        >
                            <ActionButton buttonText={props.draftAgreementMaintenanceGeneralDataViewData?.fields.find(v => v.name == "confirmAndSubmitRegistration")?.data}
                                buttonAction={() => handleSubmit()}
                                className="button btn-defaultPrimary btn-confirm"
                                data-testid={'confirm-submit-registration'}
                                showTooltip={!hasPermission}
                                disabled={!changesMade} />
                        </div>
                    </>
                )}
            </div>
            {validationErrors && <MessageBanner resetMessageBanner={renderCloseErrorMessages} messageType={MessageType.Danger} messages={errorMessages} />}
        </>
    );
};
export default DraftAgreementsMaintenanceForm;